<template>
  <section
    class="client-listing-area h-100"
    style="background: none !important; width: 100%;"
  >
    <div class="client-listing-head-fluid" style="border-bottom: 0px;">
      <div class="container">
        <div class="client-listing-head">
          <ReviewListBar @search="handleSearch" />
        </div>
        <!-- ends client-listing-head -->
      </div>
    </div>
    <!-- ends client-listing-head-fluid -->
    <div class="client-listing-detail-fluid">
      <div class="container">
        <div class="client-listing-detail">
          <div class="table-responsive">
            <ReviewListsWithDragDrop :searchQuery="searchQuery" />
          </div>
        </div>
        <!-- ends client-listing-detail -->
      </div>
    </div>
    <!-- ends client-listing-detail-fluid -->
  </section>
</template>

<script>
import ReviewListBar from './ReviewListBar.vue';
import ReviewListsWithDragDrop from './ReviewListsWithDragDrop.vue';
import { checkIsReviewerAndRedirect } from '@/utils/checkReviewer.js';

export default {
  name: 'ReviewList',
  routerViewName: 'review-list',
  components: { ReviewListBar, ReviewListsWithDragDrop },
  data() {
    return {
      searchQuery: '',
    };
  },
  mounted() {
    this.changeBodyToWhite();
  },
  beforeRouteEnter(to, from, next) {
    checkIsReviewerAndRedirect
      .call('/applicant', this)
      .then(() => {
        next();
      })
      .catch(() => {
        next();
      });
  },
  methods: {
    handleSearch(query) {
      this.searchQuery = query;
    },
  },
};
</script>
